import { ChangeDetectionStrategy, Component, inject, signal } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';

const REASON_MAX_LENGTH = 500;

@Component({
	selector: 'app-reject-bonus-dialog',
	standalone: true,
	changeDetection: ChangeDetectionStrategy.OnPush,
	imports: [FormsModule, MatButtonModule, MatDialogModule, MatFormFieldModule, MatInputModule],
	template: `
		<h2 mat-dialog-title>Odrzucenie pozycji</h2>
		<mat-dialog-content>
			<p class="reject-lead">
				Odrzucona pozycja zniknie z rozliczenia wynagrodzenia i nie będzie można rozliczać jej dni. Możesz ją
				później przywrócić.
			</p>
			<mat-form-field appearance="outline" class="reject-field" subscriptSizing="dynamic">
				<mat-label>Powód odrzucenia (opcjonalnie)</mat-label>
				<textarea
					matInput
					rows="3"
					[maxlength]="reasonMaxLength"
					[ngModel]="reason()"
					(ngModelChange)="reason.set($event)"
				></textarea>
			</mat-form-field>
		</mat-dialog-content>
		<mat-dialog-actions align="end">
			<button mat-button (click)="cancel()">Anuluj</button>
			<button mat-flat-button color="warn" (click)="accept()">Odrzuć</button>
		</mat-dialog-actions>
	`,
	styles: [
		`
			.reject-lead {
				margin: 0 0 12px;
				font-size: 13px;
				color: rgba(0, 0, 0, 0.6);
			}

			.reject-field {
				width: 100%;
				min-width: 360px;
			}
		`,
	],
})
export class RejectBonusDialogComponent {
	protected readonly reasonMaxLength = REASON_MAX_LENGTH;
	protected readonly reason = signal<string>('');

	private readonly dialogRef = inject(MatDialogRef<RejectBonusDialogComponent, string | null>);

	protected cancel(): void {
		this.dialogRef.close();
	}

	protected accept(): void {
		const reason = this.reason().trim();
		this.dialogRef.close(reason.length > 0 ? reason : null);
	}
}
